<template>
    <svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1080 1080" style="enable-background: new 0 0 1080 1080" xml:space="preserve">
        <g>
            <circle class="st0" cx="540" cy="540" r="537" />
            <g>
                <rect x="176.6" y="265.9" class="st1" width="121.3" height="109.3" />
                <rect x="782.1" y="265.9" class="st1" width="121.3" height="109.3" />
                <polygon
                    class="st1"
                    points="782.1,595.2 660.8,595.2 660.8,484.8 781.1,484.8 781.1,375.4 660.8,375.4 540.6,375.4 539.4,375.4 
			419.2,375.4 297.9,375.4 297.9,484.8 419.2,484.8 419.2,595.2 297.9,595.2 297.9,484.8 176.6,484.8 176.6,595.2 176.6,704.6 
			297.9,704.6 297.9,814.1 419.2,814.1 419.2,704.6 539.4,704.6 540.6,704.6 660.8,704.6 660.8,814.1 781.1,814.1 781.1,704.6 
			782.1,704.6 782.5,704.6 903.4,704.6 903.4,595.2 903.4,484.8 782.1,484.8 		"
                />
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: "IconHaikara",
    props: ["color"],
};
</script>

<style scoped>
.st0 {
    fill: #ff000f;
}
.st1 {
    fill: #ffffff;
}
</style>
